<template>
  <el-row>
    <el-col>
      <el-card shadow="never">
        <TeamBlockedAutobooksTable
          ref="blockedAutobooksTable"
          :account-id="$route.params.accountId"
          :team-id="$route.params.teamId"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import TeamBlockedAutobooksTable from '@/components/Application/Manage/Account/TeamBlockedAutobooksTable'

export default {
  components: {
    TeamBlockedAutobooksTable
  },
  data () {
    return {
      actions: [],
      breadcrumb: {
        name: 'Blocked Autobooks',
        route: { name: 'manage-accounts-account-configurations-teams-team-blockedautobooks', params: { accountId: this.$route.params.accountId, teamId: this.$route.params.teamId } }
      }
    }
  },
  mounted () {
    this.actions = this.$refs.blockedAutobooksTable.actions
  }
}
</script>

<style>

</style>
